/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type BeginSlackDirectoryConnectionRequestBody = {
  /**
   * Reconnect this workspace.
   */
  connectionId?: string | undefined;
};

/** @internal */
export type BeginSlackDirectoryConnectionRequestBody$Outbound = {
  connection_id?: string | undefined;
};

/** @internal */
export const BeginSlackDirectoryConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    BeginSlackDirectoryConnectionRequestBody$Outbound,
    BeginSlackDirectoryConnectionRequestBody
  > = z.pipe(
    z.object({
      connectionId: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        connectionId: "connection_id",
      });
    }),
  );

export function beginSlackDirectoryConnectionRequestBodyToJSON(
  beginSlackDirectoryConnectionRequestBody:
    BeginSlackDirectoryConnectionRequestBody,
): string {
  return JSON.stringify(
    BeginSlackDirectoryConnectionRequestBody$outboundSchema.parse(
      beginSlackDirectoryConnectionRequestBody,
    ),
  );
}
